import { getCookie } from '../../utils/cookie';
import { TRANSLATIONS_PERSIST_KEY } from './const';

import { modules, modulesMetaData } from '../../components/CrossModuleLink/modules';
import { getPageUrl } from '../../components/CrossModuleLink/utils';
import { decodeListDataFilter } from '../list';
import { CustomObject } from '../../types';

const languageSessionStorageId = '__LANGUAGE__';

export const getCachedTranslations = (id) => {
	const serializedTranslations = sessionStorage.getItem(`${languageSessionStorageId}${id}`);

	if (typeof serializedTranslations === 'undefined' || serializedTranslations === null) {
		return null;
	}

	try {
		return JSON.parse(serializedTranslations);
	} catch (e) {
		return null;
	}
};

export const cacheTranslations = (id, data) => {
	if (!data) {
		return;
	}

	return sessionStorage.setItem(`${languageSessionStorageId}${id}`, JSON.stringify(data));
};

export const hasCachedLanguage = (id) => {
	return getCachedTranslations(id) !== null;
};

export function getActiveLanguage() {
	const defaultLanguage = 'en';
	const cookieLanguage = getCookie('language');

	return cookieLanguage || defaultLanguage;
}

export function getPersistedTranslations() {
	const dataFromStorage = window.localStorage.getItem(TRANSLATIONS_PERSIST_KEY);

	if (dataFromStorage === null) {
		return null;
	}

	return JSON.parse(dataFromStorage) as CustomObject;
}

export const getTranslationDetailUrl = (entityId: number | null, labelId: number | null, listData: string): string => {
	if (!entityId) {
		return '';
	}

	return getPageUrl({
		module: modules.TRANSLATION,
		route: modulesMetaData[modules.TRANSLATION].detail,
		routeParam: entityId,
		params: {
			labelId,
			listData: listData,
		},
	});
};

export const getTranslationListUrl = (search: string): string => {
	const urlSearchParams = new URLSearchParams(search);

	return getPageUrl({
		module: modules.TRANSLATION,
		route: modulesMetaData[modules.TRANSLATION].list,
		params: decodeListDataFilter(urlSearchParams.get('listData')),
	});
};
